import { configureStore } from '@reduxjs/toolkit'
import userDataReducer from '../Slices/slice'

export const store = configureStore({
  reducer: {
    Store: userDataReducer,
  },
})